module.exports = __webpack_public_path__ + "img/logo_bajo.65eecd8e.png";